export default __webpack_public_path__ + "static/media/shantell-sans-v9-latin-700.dfb6644d.woff2";